<template>
  <div class="app">
    <div class="m-viewport" id="mainView">

        <div class="cover">
            <div class="video">
                <!-- <video :src="'https://web-resource.17m3.com/m3guo/202601/he/banner.webm?v=' + randomKey" autoplay loop muted></video> -->
            </div>
            
            <div class="layer-stone"></div>
        </div>

        <div class="logo-view">
          <h2 class="logo_1 sprite sprite-logo"><a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></h2>
        </div>
        
        <div class="u-links">
            <div class="btn-index sprite sprite-btn-index">
                <a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a>
            </div>
            <div class="btn-dl sprite sprite-btn-dl">
              <a href="https://www.m3guo.com/v2/download/client/" target="_blank" rel="noopener noreferrer"></a>
            </div>
        </div>
        
        <div class="u-btn copyright">
            <!-- todo -->
        </div>

        <div class="m-user">
            <user-info class="text-overflow-1"/>
        </div>


        <div class="u-btn invite" @click="call_share()">
            <span class="invite-shine" aria-hidden="true"></span>
        </div>

        <sns/>
        
        <loading v-show="Loading"/>
     
        <div class="page-body">
            <div class="page-wrapper" v-if="ready">
                <treasure-update data-aos="fade-up"/>
                <hero-skin data-aos="fade-up" style="margin-top: 163px;"/>
                <map-update data-aos="fade-up" style="margin-top: 163px;"/>
                <new data-aos="fade-up" style="margin-top: 233px;"/>
                <web-evt style="margin-top: 233px;"/>
            </div>
        </div>

    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import { apiScoreInfo,apiShare, } from '@/api/index';

export default {
    name: 'mainview',
    components: {
        loading: () => import('@/components/loading.vue'),
        'treasure-update': () => import('@/views/treasureUpdate.vue'),
        'hero-skin': () => import('@/views/heroSkin.vue'),
        'map-update': () => import('@/views/mapUpdate.vue'),
        'new' : () => import('@/views/new.vue'),
        'web-evt' : () => import('@/views/webEvt.vue'),
        sns : () => import('@/components/sns.vue'),
    },
    data (){
        return {
            sns : false,
            randomKey : Math.random().toString(36).substring(2,8),
        }
    },
    computed : {
        ...mapState(['Loading'])
    },    
    props : {
        ready : {
            default : false,
        },
    },
    methods : {
        call_share(){
            if(!this.$store.state.login){
                return this.$mslogin.login();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }
            
            apiShare({}).then(
                res => {
                    let shareTxt = res.data.koudai  ? (res.data.koudai + res.data.url) : res.data.url; 
                    this.$copy_modal({ shareTxt : shareTxt});                   
                },
                rej => {
                    this.$toast(rej.message)
                }
            )            
        },
    }, 
}
</script>

<style>
@keyframes rockFloat {
  0% {
    transform: translate3d(0, 0, 0) rotate(-1.4deg);
  }
  25% {
    transform: translate3d(-2px, -8px, 0) rotate(0.8deg);
  }
  50% {
    transform: translate3d(0, -14px, 0) rotate(1.6deg);
  }
  75% {
    transform: translate3d(2px, -7px, 0) rotate(0deg);
  }
  100% {
    transform: translate3d(0, 0, 0) rotate(-1.4deg);
  }
}

@keyframes rockShadow {
  0%, 100% {
    transform: translateX(-50%) scale(1);
    opacity: 0.26;
  }
  50% {
    transform: translateX(-50%) scale(0.86);
    opacity: 0.16;
  }
}

@keyframes nebulaDrift {
  0%   { transform: translate(-1.5%, -1%) rotate(0deg); }
  100% { transform: translate(1.5%, 1%) rotate(4deg); }
}

@keyframes inviteFloat {
    0%, 100% {
        transform: translate3d(0, 0, 0) scale(1);
    }
    50% {
        transform: translate3d(0, -5px, 0) scale(1.03);
    }
}

@keyframes invitePulse {
    0% {
        transform: scale(0.84);
        opacity: 0;
    }
    24% {
        opacity: 0.72;
    }
    100% {
        transform: scale(1.24);
        opacity: 0;
    }
}

@keyframes inviteGlow {
    0%, 100% {
        opacity: 0.44;
        transform: translate(-50%, -50%) scale(0.95);
    }
    50% {
        opacity: 0.98;
        transform: translate(-50%, -50%) scale(1.08);
    }
}

@keyframes inviteSweep {
    0%, 56% {
        left: -62%;
        opacity: 0;
    }
    62% {
        opacity: 0.9;
    }
    100% {
        left: 124%;
        opacity: 0;
    }
}

/* 可访问性：用户关闭动画时尊重系统设置 */
@media (prefers-reduced-motion: reduce) {
  .floating-rock,
    .floating-rock .rock-shadow,
    .u-btn.invite,
    .u-btn.invite::before,
    .u-btn.invite::after,
    .u-btn.invite .invite-shine::after {
    animation: none;
  }
}
</style>

<style lang="scss" scoped>
.m-viewport{
    position: relative;
    width: 100%;
    margin: 0 auto 0;
    min-width: 1200px;
    max-width: 1920px;
    // height: 5104px;
    // padding-top: 830px;
    background-repeat: no-repeat;
    background-position: center top;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: hidden;
    // background-image: url(~@/assets/images/pc/body.jpg);   
    z-index: 20;
    box-sizing: border-box;
    font-size: 16px;
    background-color: #1c1f1c;
    font-family: 'HYChangLiSongKeBenJ','Microsoft YaHei',sans-serif;

    b{
        font-weight: 400;
        color: #26c7da;        
    }
}

.cover{
    position: relative;
    width: 100%;
    height: 1080px;
    margin: 0 auto;
    z-index: 5;
    background-repeat: no-repeat;
    background-position: center top;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: hidden;    
    background-image: url(~@/assets/images/pc/cover.jpg);

    &::after{
        content: "";
        position: absolute;
        left: 50%;
        bottom: -1px;
        width: 100%;
        height: 523px;
        transform: translate(-50%,0);
        background-image: url(~@/assets/images/pc/layer-video.png);
    }

    .layer-stone{
        position: absolute;
        left: 50%;
        bottom: 0;
        width: 1602px;
        height: 523px;
        margin-left: -801px;
        background-image: url(~@/assets/images/pc/layer-stone.png);
        transform-origin: 50% 65%;
        animation: rockFloat 4.8s ease-in-out infinite;
        will-change: transform;        
    }

    .video{
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, 0);
        width: 100%;
        height: 100%;
    }

    video{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border: none;
        mix-blend-mode: darken; 
    }

    video:focus {
        outline:none;
    }
}

.m-user{
    position: absolute;
    left: 50%;
    top: 654px;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    transform: translateX(-50%);
    background-color: rgba($color: #4e311d, $alpha: 0.8);
    border: 1px solid #b17645;
    border-radius: 20px;
    z-index: 11;
    font-size: 16px;
    
}

.u-btn.invite{
    position: absolute;
    left: 50%;
    top: 650px;
    width: 254px;
    height: 254px;
    margin-left: -127px;
    background-image: url(~@/assets/images/pc/btn-share.png); 
    z-index: 10;
    transform-origin: center;
    animation: inviteFloat 2.2s ease-in-out infinite;
    cursor: pointer;

    &::before{
        content: "";
        position: absolute;
        inset: -16px;
        border-radius: 50%;
        background: radial-gradient(circle, rgba(255,205,120,0.42) 0%, rgba(255,205,120,0.14) 42%, rgba(255,205,120,0) 72%);
        animation: invitePulse 1.8s ease-out infinite;
        pointer-events: none;
    }

    &::after{
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        width: 136px;
        height: 136px;
        margin-left: -68px;
        margin-top: -68px;
        background-image: url(~@/assets/images/pc/layer-light.png);
        filter: blur(8px);
        animation: inviteGlow 1.6s ease-in-out infinite, nebulaDrift 10s ease-in-out infinite alternate;
        pointer-events: none;
    }

    .invite-shine{
        position: absolute;
        width: 136px;
        height: 136px;
        left: 50%;
        top: 50%;
        margin-left: -68px;
        margin-top: -68px;
        border-radius: 50%;
        overflow: hidden;
        pointer-events: none;

        &::after{
            content: "";
            position: absolute;
            top: -18%;
            left: -62%;
            width: 40%;
            height: 140%;
            transform: rotate(18deg);
            background: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,0.55), rgba(255,255,255,0));
            animation: inviteSweep 2.6s ease-in-out infinite;
        }
    }
}

.logo-view{
    display: flex;
    align-items: center;
    position: absolute;
    left: 2%;
    top:30px;
    z-index: 10;
}

.logo-view a{
    display: block;
    width: 100%;
    height: 100%;
}

.u-links{
    display: flex;
    position: absolute;
    right: 4%;
    top: 30px;
    z-index: 6; 
    
    &>div{
        margin-left: 20px;
    }
}

.u-links a{
    display: block;
    width: 100%;
    height: 100%;
}

.page-body{
    position: relative;
    width: 100%;
    min-width: 1200px;
    max-width: 1920px;
    height: 5104px;
    background-repeat: no-repeat;
    background-position: center top;
    box-sizing: border-box;
    // overflow-x: hidden;
    background-image: url(~@/assets/images/pc/body.jpg); 
    z-index: 6; 
}

.page-wrapper{   
    position: relative;
    transform: translateY(-140px);
    width: 1400px;
    margin: 0 auto 0;
}
</style>

<style lang="scss">

.view-data{
    font-size: 18px;
    font-weight: 700;
    color: #5b734f;

    b{
        font-size: 22px;
        color: #b98222;
    }
}

.reward-list{
    display: flex;
    justify-content: center;
    gap : 28px;
    flex-wrap: wrap;
    margin-bottom: 10px;
}

.reward-item{

}

.reward-pic{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 56px;
    height: 56px;
    background: url('@/assets/images/pc/bg-item.png') no-repeat center;

    .pic-wrapper{
        width: 46px;
        height: 46px;
    }
}
</style>